import { FC, ReactNode } from 'react';

import { Tag } from '@eluve/components';

import {
  EXCLUDED_TAG,
  LifecycleStatus,
  getLifecycleStatusTagProps,
} from './lifecycle-status';

type LifecycleStatusTagProps = {
  status: LifecycleStatus | null | undefined;
  /**
   * When the user is excluded, the Status cell shows "Excluded" instead of the
   * lifecycle status — exclusion takes precedence (ENG-4694, design Image #3).
   * Owning this precedence here keeps both Users pages from re-deriving it.
   */
  isExcluded?: boolean;
  children?: ReactNode;
};

/**
 * Color-coded lifecycle status cell shared by the Org Admin and Admin Dash
 * Users pages (ENG-4694). Renders nothing for invite rows, which have no
 * `tenant_users` row and therefore no lifecycle status.
 */
export const LifecycleStatusTag: FC<LifecycleStatusTagProps> = ({
  status,
  isExcluded = false,
  children,
}) => {
  const tag = isExcluded ? EXCLUDED_TAG : getLifecycleStatusTagProps(status);
  if (!tag) {
    return null;
  }
  return (
    <Tag color={tag.color} label={tag.label} size="s">
      {children}
    </Tag>
  );
};
